import { render, staticRenderFns } from "./WfButton.vue?vue&type=template&id=47d9b0a1&scoped=true"
import script from "./WfButton.vue?vue&type=script&lang=js"
export * from "./WfButton.vue?vue&type=script&lang=js"
import style0 from "./WfButton.vue?vue&type=style&index=0&id=47d9b0a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9b0a1",
  null
  
)

export default component.exports